/**
 * 接口域名的管理
 */
const base = {    
  test:"http://49.66.134.182:5555",
  api:"http://data-center.91pitu.com",
  dev: 'https://hanxin.tst.91pitu.com',    //开发域名
  pd: 'https://hanxin.prd.91pitu.com'          //生产域名
}
export default base;